var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"member-classes-period-type"},[_vm._v("\n    "+_vm._s(_vm.CoursePeriodsType.getValue(_vm.periods_type))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }